import React, { useEffect, useRef } from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import { ButtonGroup, Button, FormGroup, Label } from 'reactstrap'
import { AnalyzerFormValues } from '../analyzerForm.types'

const AnalyzerTypeSelector = ({ isAdmin }: { isAdmin: boolean }) => {
  const { control, setValue, trigger, getValues } =
    useFormContext<AnalyzerFormValues>()
  const options = ['Manual', ...(isAdmin ? ['Ingress'] : [])] as const

  const selectedType = useWatch({ control, name: 'type' })
  const datasetId = useWatch({ control, name: 'datasetId' })

  // Store last known dataset per type
  const lastDatasetsRef = useRef<Record<string, string | undefined>>({})

  // Track initial type to skip dataset reset on first render
  const initialTypeRef = useRef<string | undefined>(selectedType)

  useEffect(() => {
    const prevType = initialTypeRef.current

    if (prevType !== selectedType) {
      // Store current dataset value for previous type
      if (prevType) {
        lastDatasetsRef.current[prevType] = getValues('datasetId')
      }

      // Restore dataset for new type if available
      const previousDataset = lastDatasetsRef.current[selectedType]

      setValue('datasetId', previousDataset ?? '', {
        shouldValidate: false,
        shouldDirty: true
      })

      // Update initial type to current
      initialTypeRef.current = selectedType
    }
  }, [selectedType, getValues, setValue, trigger])

  return (
    <FormGroup>
      <Label>Type</Label>
      <div className="mt-1 d-flex gap-2 flex-wrap">
        <Controller
          name="type"
          control={control}
          render={({ field }) => (
            <ButtonGroup>
              {options.map((option) => (
                <Button
                  key={option}
                  color="light"
                  onClick={() => field.onChange(option)}
                  active={field.value === option}
                >
                  {option}
                </Button>
              ))}
            </ButtonGroup>
          )}
        />
      </div>
    </FormGroup>
  )
}

export default AnalyzerTypeSelector
